import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .full-paragraph {
    word-break: break-word;
    width: 100%;

    .full-paragraph-topic {
      margin-bottom: 16px;
    }

    .title-wrapper {
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .paragraph-body-wrapper {
    }

    .bullets-wrapper {
      margin-top: 32px;
      display: flex;

      &.left {
        justify-content: flex-start;
        .bullets {
          justify-content: flex-start;
        }
      }

      &.center {
        justify-content: center;
        .bullets {
          justify-content: center;
        }
      }

      &.right {
        justify-content: flex-end;
        .bullets {
          justify-content: flex-end;
        }
      }
    }

    .button-wrapper {
      margin-top: 32px;
      display: flex;

      &.left {
        justify-content: flex-start;
      }

      &.center {
        justify-content: center;
      }

      &.right {
        justify-content: flex-end;
      }
    }
  }
`;
